import { Blocks } from '@/components/PageEditor/types';
import { ContentType } from '@/modules/corporate/modules/course/views/CourseBuilder/components/Sidebar/types';

import { onMovePayloadType } from '../types';
import { AddLevels } from '../views/CourseBuilder/components/SidebarDetails/enums';
import { findContentById, getLessonIndex, getLessonsParent } from './courseActions';

export const getLevel = (id: string, rootLessons?: ContentType[], movedItem?: ContentType) => {
  const isMovedItemRootLesson = getLessonIndex(rootLessons!, id!) !== -1;
  const movedItemLev =
    movedItem?.type === Blocks.SECTION
      ? AddLevels.First
      : isMovedItemRootLesson
      ? AddLevels.Second
      : AddLevels.Third;

  return movedItemLev;
};

export const getIsValidMove = (
  id: string,
  movedItem: ContentType,
  addToLev: AddLevels,
  lessonsParent: ReturnType<typeof getLessonsParent>,
  rootLessons?: ContentType[],
) => {
  const isMovedItemParent = Object.values(lessonsParent).findIndex((item) => item === id) !== -1;
  const movedItemLev = getLevel(id, rootLessons, movedItem);

  if (addToLev === AddLevels.First || movedItemLev === AddLevels.First) {
    return addToLev === AddLevels.First && movedItemLev === AddLevels.First;
  }
  return addToLev === AddLevels.Third ? !isMovedItemParent : true;
};

export const getMoveItems = (
  payload: onMovePayloadType,
  lessonsParent: ReturnType<typeof getLessonsParent>,
  movedItem?: ContentType,
  dropOnItem?: ContentType,
  data?: ContentType,
  sequentialItems?: ContentType[],
  rootLessons?: ContentType[],
) => {
  const { id, addLevel, toId } = payload;
  const isDroppedOnParent =
    addLevel === AddLevels.Second
      ? dropOnItem?.type === Blocks.SECTION
      : getLessonIndex(rootLessons!, toId) !== -1; //for second and third level

  const fromItem =
    movedItem?.type === Blocks.SECTION
      ? data
      : findContentById(sequentialItems, lessonsParent[id!]);

  const toItem =
    addLevel === AddLevels.First
      ? data
      : findContentById(sequentialItems, isDroppedOnParent ? toId : lessonsParent[toId!]);

  return { fromItem: fromItem?.content, toItem: toItem?.content };
};
